import {isRouteErrorResponse, Link, useRouteError} from "react-router-dom";

const ErrorPage = () => {
  const error:any = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      {isRouteErrorResponse(error) ? (
        <h1>
          {error.status} {error.statusText}
        </h1>
      ) : (
        <h1>{error.message || error}</h1>
      )}
      <Link to="/">Go to Home</Link>
    </div>
  );
};

export default ErrorPage;